import { PartOrder } from 'app/models/PartOrder';
import { Tour } from 'app/models/Tour';

export interface DeliveryJson {
  id: number;
  order?: any; //number;
  partOrder?: number;
  tour: Tour | number;
  position: number;
  manual: boolean;
  notification: boolean;
  confirmed: boolean;
  confirmationReminderCount: number;
  duration?: number;
  deliveryTime?: string;
  customerTime?: string;
  unloadingTime: number;
  waypoint?: number;
  waypointNote?: string;
  carrierOrderId?: string;
  carrierStatus?: string;
  carrierError?: boolean;
  delivered: boolean;
  deliveredAt: string;
  status: string;
}

export interface Delivery extends DeliveryJson {
  order?: PartOrder;
  assembly: boolean;
}

function getStatus(data: DeliveryJson, partOrder: PartOrder | undefined) {
  // Return the status of the delivery
  /*
    List of status:
      CREATED: Not in a tour yet
      SCHEDULED: default for a tour with date in the future
      IN_TRANSIT: current day of the tour and not yet delivered
      DELIVERED: the customer has receive his packages
      DELIVERY_FAILED: 	Unable to deliver (e.g. no one home, address issue).
   */

  return '';
}

export const createDelivery = (
  data: DeliveryJson,
  partOrder?: PartOrder,
): Delivery => {
  return {
    ...data,
    order: partOrder,
    assembly: !!partOrder?.orderInfo.assembly,
    status: getStatus(data, partOrder),
  };
};
